import { TituloValidadorDirective } from './titulo-validador.directive ';
import { PisValidadorDirective } from './pis-validador.directive';
import { RemoveCaracterPipe } from './remove-caracter.pipe';
import { AteDataDirective } from './ate-data.directives';
import { ApartirDataDirective } from './apartir-data.directives';
import { BetWeenDataDirective } from './between-data.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CamposIguaisDirective } from './campos-iguais.directive';
import { CpfValidadorDirective } from './cpf-validador.directive';
import { MaiorQueDirective } from './maior-que.directive';
import { ReduzTextoPipe } from './reduz-texto.pipe';
import { SafeUrlPipe } from './safe-url';
import { ImageEntidadePipe } from './image-entidade.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    RemoveCaracterPipe,
    CamposIguaisDirective,
    CpfValidadorDirective,
    MaiorQueDirective,
    ReduzTextoPipe,
    SafeUrlPipe,
    BetWeenDataDirective,
    AteDataDirective,
    ApartirDataDirective,
    ImageEntidadePipe,
    PisValidadorDirective,
    TituloValidadorDirective
  ],
  exports : [
    RemoveCaracterPipe,
    CamposIguaisDirective,
    CpfValidadorDirective,
    MaiorQueDirective,
    ReduzTextoPipe,
    SafeUrlPipe,
    BetWeenDataDirective,
    AteDataDirective,
    ApartirDataDirective,
    ImageEntidadePipe,
    PisValidadorDirective,
    TituloValidadorDirective
  ]
})
export class ValidadoresModule { }
